var Request = require('../helper/request');
var queryString = require('query-string');

function Feed(app, companyId){
  var self = this;
  self.request = new Request(app);
  self.companyId = companyId;

  self.routes = {
    index: {
      url: '/company/'+self.companyId+'/feed',
      method: "GET"
    },
    create: {
      url: '/company/'+self.companyId+'/feed',
      method: "POST"
    },
    delete: {
      url: '/company/'+self.companyId+'/feed/:id',
      method: "DELETE"
    }
  }
}

/*
*  Data: [branch_id, category_id, type, significany]
*/
Feed.prototype.index = function(data = false){
  var self = this;
  var uri = self.routes.index.url + '?page=1';
  
  if (data){
    uri = uri + "&" + queryString.stringify(data);
  }

  return self.request.get(uri);
}

/*
*  Data: [branch_id, category_id, type, significany]
*/
Feed.prototype.paginate = function(page, data = false){
  var self = this;
  var uri = self.routes.index.url + '?page=' + page;
  
  if (data){
    uri = uri + "&" + queryString.stringify(data);
  }

  return self.request.get(uri);
}

Feed.prototype.create = function(data){
  var self = this;
  var uri = self.routes.create.url;
  return self.request.post(uri, {
    feed: data
  });
}

Feed.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri);
}

module.exports = Feed;
